import MobileDetect from "mobile-detect"

export function isMobileDevice() {
    if (import.meta.client) {
        return new MobileDetect(navigator.userAgent).mobile() !== null
    }
}
